import { ModuleDTO } from '../../dto/module/module.dto';
import { ModuleVersionDTO } from '../../dto/module/module-version.dto';

export class Module {
    module_id: number | undefined;
    base_module_id: number | undefined;
    name: string;
    descriptions: { [key: string]: { language_code: string, translation_text: string } };
    visibility: string;
    subtypes: Array<{ subtype_id: number }> = [];
    maintenance_minutes: number;
    versions: ModuleVersion[] = [];

    constructor(
        name: string,
        descriptions: { [key: string]: { language_code: string, translation_text: string } },
        visibility: string = 'public',
        subtypes: Array<{ subtype_id: number }> = [],
        maintenance_minutes: number = 0,
        module_id?: number,
        base_module_id?: number       
    ) {
        this.name = name;
        this.descriptions = descriptions;
        this.visibility = visibility;
        this.subtypes = subtypes;
        this.maintenance_minutes = maintenance_minutes;
        this.module_id = module_id;
        this.base_module_id = base_module_id;
    }

    public static convertToDTO(model: Module): ModuleDTO {
        return {
            name: model.name,
            descriptions: model.descriptions,
            visibility: model.visibility,
            subtypes: model.subtypes,
            module_id: model.module_id,
            base_module_id: model.base_module_id,
            maintenance_minutes: model.maintenance_minutes,
            versions: model.versions.map(v => ModuleVersion.convertToDTO(v))
        };
    }

    public static fromDTO(dto: ModuleDTO): Module {
        const module = new Module(
          dto.name,
          dto.descriptions,
          dto.visibility,
          dto.subtypes,
          dto.maintenance_minutes,
          dto.module_id,
          dto.base_module_id
        );
        
        if (dto.versions) {
            module.versions = dto.versions.map(v => ModuleVersion.fromDTO(v));
        }
        
        return module;
    }
}

export class ModuleVersion {
    constructor(
        public version_id: number,
        public module_id: number,
        public name: string,
        public descriptions: { [key: string]: { language_code: string, translation_text: string } },
        public valid_from: string,
        public valid_to: string | null,
        public maintenance_minutes: number,
        public visibility: string
    ) {}

    public static convertToDTO(version: ModuleVersion): ModuleVersionDTO {
        return {
            version_id: version.version_id,
            module_id: version.module_id,
            name: version.name,
            descriptions: version.descriptions,
            valid_from: version.valid_from,
            valid_to: version.valid_to,
            maintenance_minutes: version.maintenance_minutes,
            visibility: version.visibility
        };
    }

    public static fromDTO(dto: ModuleVersionDTO): ModuleVersion {
        return new ModuleVersion(
            dto.version_id,
            dto.module_id,
            dto.name,
            dto.descriptions,
            dto.valid_from,
            dto.valid_to,
            dto.maintenance_minutes,
            dto.visibility
        );
    }
} 